<script>
	import Icone from './../Icone.svelte';
	import { sTema } from '../../stores';
	
	export let dados = {};
	export const parametros = {};
</script>

<style>
	.box {
		position: relative;
		top: 0;
		margin: 10px;
		height: 200px;
		width: 200px;
		padding: 0 !important;
		text-align: center;
		transition: all 0.5s cubic-bezier(.25, .8, .25, 1);
	}
	.box:hover {
		position: relative;
		top: -4px;
		cursor: pointer;
		box-shadow: 0 14px 28px rgba(0, 0,0 , 0.26), 0 10px 10px rgba(0, 0, 0, 0.21);
	}

	.areaicone {
		padding: 10px;
	}

	.icone {
		height: 100px;
		margin-bottom: 40px;
	}

	.rodapecard {
		height: 40px;
	}

	.fixtopimage {
		top: 6px;
	}

	.borda-noite {
		border: 1px solid #aaa;
	}

	.cor-titulo-noite {
		color: #cc6bff;
	}

	.divscroll {
		overflow-y: auto;
		overflow-x: hidden;
		padding: 5px;
		text-align: left;
		height: 200px;
	}

	.divscroll::-webkit-scrollbar {
		width: 6px;
	}

	.divscroll::-webkit-scrollbar-track {
		box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
		border-radius: 5px;
	}

	.divscroll::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 4px rgba(0,0,0,0.6); 
	}
</style>

<a href="{dados.link ?? '#link-invalido'}"> 
	<div class="box {$sTema == "dia" ? "" : "has-background-dark borda-noite"}">
		{#if dados.icone != null}
		<div class="areaicone">
			<div class="icone">
				<figure class="image container is-128x128 fixtopimage">
					<Icone tipo={dados.icone} cor={$sTema == "dia" ? "#000" : "#fff"} />
				</figure>
			</div>
		</div>
		<h1 class="is-size-5 has-text-primary has-text-centered rodapecard">
			<strong class="{$sTema == "dia" ? "has-text-primary" : "cor-titulo-noite"}">{dados.titulo}</strong>
		</h1>
		{:else}
		<div class="has-text-left divscroll">
			{#if dados.tag != null}
			<span class="tag my-2">{dados.tag}</span>
			<br>
			{/if}
			<strong class="{$sTema == "dia" ? "has-text-primary" : "cor-titulo-noite"} is-size-5 has-text-primary">{dados.titulo}</strong>
			{#if dados.descricao != null}
			<hr>
			<small class="{$sTema == "dia" ? "has-text-primary" : "has-text-white"}">{dados.descricao}</small>
			{/if}
		</div>
		{/if}
	</div>
</a>
